import { Grid } from "@mui/material";
import VmVCardKeys from "../VmVCardKeys";
import { useQuery } from "@tanstack/react-query";
import { fetchData } from "../../helpers/fetch";
import { useTranslation } from "react-i18next";

interface HomeCardsData {
  daysRemainingParticipation: number;
  daysRemainingInscription: number;
  collaborateursCount: number;
  etablissementsCount: number;
}

const HomeCards = (): JSX.Element => {
  const { t } = useTranslation();
  const { data } = useQuery({
    queryKey: ["misc/first-page-stat"],
    queryFn: async () => await fetchData("misc/first-page-stat"),
  });

  return (
    <Grid container justifyContent="center" my={15}>
      <Grid item lg={2} sm={6} xs={12}>
        <VmVCardKeys
          title={
            (data as HomeCardsData)?.daysRemainingInscription > 0
              ? `J -${(data as HomeCardsData)?.daysRemainingInscription}`
              : t("pages.home.cards.closed")
          }
          subtitle={t("pages.home.cards.participationDeadline")}
          description={
            (data as HomeCardsData)?.daysRemainingInscription > 0
              ? t("pages.home.cards.beforeClosure")
              : ""
          }
        />
      </Grid>
      <Grid item lg={4} sm={6} xs={12}>
        <VmVCardKeys
          title={`${(data as HomeCardsData)?.etablissementsCount ?? 0} ${t(
            "pages.home.cards.participations",
          )}`}
          subtitle={t("pages.home.cards.totalEstablishmentParticipations")}
        />
      </Grid>
      <Grid item lg={2} sm={6} xs={12}>
        <VmVCardKeys
          title={
            (data as HomeCardsData)?.daysRemainingParticipation > 0
              ? `J -${(data as HomeCardsData)?.daysRemainingParticipation}`
              : t("pages.home.cards.closed")
          }
          subtitle={t("pages.home.cards.registrationDeadline")}
          description={
            (data as HomeCardsData)?.daysRemainingParticipation > 0
              ? t("pages.home.cards.beforeClosure")
              : ""
          }
          color={"green"}
        />
      </Grid>
      <Grid item lg={4} sm={6} xs={12}>
        <VmVCardKeys
          title={`${(data as HomeCardsData)?.collaborateursCount ?? 0} ${t(
            "pages.home.cards.registrations",
          )}`}
          subtitle={t("pages.home.cards.totalCollaborators")}
          color="green"
        />
      </Grid>
    </Grid>
  );
};

export default HomeCards;
